import { filesize } from 'filesize';

export const convertFileSize = (size: number) => {
    return filesize(size, { round: 1 }).toString();
};

export const getFileExtension = (filename: string) => {
    return filename.split('.').pop();
};
